export const DEMO_FORM_SLUGS = {
  client_name: "client_name",
  company_name: "company_name",
  mobile_number: "mobile_number",
  email_address: "email_address",
  client_type: "client_type",
  agreement: "agreement",
  request_demo: "request_demo",
};
